export interface MetaClassDataModel {
    className: string;
    primaryKeyId: string;
    properties: Property[];
}

export interface Property {
    name: string;
    friendlyName: string;
    description: string;
    metaFieldType: string;
    value: any;
    isNullable: boolean;
    validationData: any;
    otherData: any;
}

export interface SearchParams {
    className: string;
    pageIndex: number;
    pageSize: number;
    keyword: string;
    sortField: string;
    sortType: SortType;
}

export interface Column {
    fieldName: string;
    friendlyName: string;
    isSystem: boolean;
}

export enum SortType {
    Asc,
    Desc,
}
